module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "dLabel",
      "id": "userOption"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v(_vm._s(_vm.$t('signOut')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4c0ff070!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plexHeader/userCenterHeader/accountInfoList/AccountInfoList.vue
// module id = 1320
// module chunks = 1